import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const ExploreRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: '$8 0',
  '& .d-only': {
    display: 'none',
  },
  '& .m-only': {
    display: 'block',
  },
  '@bp2': {
    padding: '$11 0 $5',
    '& .d-only': {
      display: 'flex',
    },
    '& .m-only': {
      display: 'none',
    },
  },
})

export const ExploreContainer = styled('div', {
  position: 'relative',
  maxWidth: '500px',
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 $2',

  '@bp2': {
    maxWidth: '1292px',
  },
})

export const Title = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',
  textAlign: 'center',
  width: '100%',
  maxWidth: '400px',
  margin: 'auto',
  marginBottom: '$6',

  '@bp2': {
    maxWidth: 'none',
    fontSize: '$h1',
    lineHeight: '$h1',
    marginBottom: '$5',
  },
})

export const LearnMoreContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid $accent-gray',
  borderRadius: '8px',
  padding: '$2',
  gap: '20px',
  width: 'fit-content',
  margin: 'auto',
  flexDirection: 'column',

  '@mobile': {
    flexDirection: 'row',
  },

  '@bp2': {
    flexDirection: 'row',
    padding: '$5 20px',
  },
})

export const RecipeCopy = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '243px',
  gap: '$1',

  '@bp2': {
    gap: '$2',
  },
})

export const BagImageWrapper = styled('div', {
  position: 'relative',
  width: '100px',
  paddingTop: '0px',
  flexShrink: 0,
  aspectRatio: '151/211',

  '@bp2': {
    width: '190px',
    paddingTop: '10px',
  },
})

export const ButtonWrapper = styled('div', {
  width: '100%',
  marginTop: '$2',
})

export const Row = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '20px',
})
